module.exports = __webpack_public_path__ + "img/kverneland_exacta_tlx_geospread.c17cdae0.jpg";